import React from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import { alertIcWarning24px } from '@ey-xd/motif-react/assets/icons';
import { useRecoilState } from 'recoil';
import { Privacy_Modal_State } from '@recoil/recoil';
import { BUTTON_TITLE, PRIVACY_STATEMENT } from '@constants/commonConstants';
import { BodyContent, HeaderWrapper, ParagraphStyle } from '@organisms/modals/styles/modalStyles';
import { isMobile } from 'react-device-detect';
import '@styles/commonStyles.css';

const PrivacyStatementModal = () => {
  const [showWarningModal, setShowWarningModal] = useRecoilState(Privacy_Modal_State);

  const closeWarningModalByCancel = () => {
    setShowWarningModal(false);
    sessionStorage.setItem('isPrivacyPopupClosedOnce', true);
  };

  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;
  const bodyContent = (
    <BodyContent>
      <p>{PRIVACY_STATEMENT.DESCRIPTION1}</p>
      <p>{PRIVACY_STATEMENT.DESCRIPTION2}</p>
      <p>{PRIVACY_STATEMENT.DESCRIPTION3}</p>
    </BodyContent>
  );
  const headerTitle = (
    <span style={{ marginLeft: 11, fontSize: 16 }}>{PRIVACY_STATEMENT.HEADER_TITLE}</span>
  );

  return (
    <MotifModal
      variant="alt"
      show={showWarningModal}
      onClose={closeWarningModalByCancel}
      size={isMobile ? 'sm' : 'md'}
      className={isMobile ? 'motif-Modal-mobile' : null}
      focusTrapOptions={{
        initialFocus: false,
      }}
    >
      <MotifModalHeader closeModalButton={true}>
        <Header>
          <MotifIcon style={{ color: '#FF9831', lineHeight: 1 }} src={alertIcWarning24px} />
          {headerTitle}
        </Header>
      </MotifModalHeader>
      <MotifModalBody>
        <ParagraphStyle> {bodyContent}</ParagraphStyle>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton variant="secondary" type="button" onClick={closeWarningModalByCancel}>
          {BUTTON_TITLE.CLOSE}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};
export default PrivacyStatementModal;
